import { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      // Backend already routes /api/contact to investors@piplight.com via Resend.
      await api.post("/contact", { ...f });
      toast.success("Message received. Thank you.");
      setF({ name: "", email: "", subject: "", message: "" });
    } catch (e) { toast.error(formatErr(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className="container-tight py-16 grid md:grid-cols-2 gap-14">
      <div>
        <div className="kicker mb-3">Contact</div>
        <h1 className="text-5xl mb-6">Speak with the firm.</h1>
        <p className="text-muted-foreground leading-relaxed mb-8">
          Your email will be responded to within the next few days.
          Regulatory and compliance inquiries should be marked as such in the subject line.
        </p>
        <dl className="text-sm space-y-4">
          <div><dt className="kicker text-[10px] mb-1">Firm</dt><dd>Piplight Capital, LLC — Quantitative Trading Division</dd></div>
          <div><dt className="kicker text-[10px] mb-1">Domain</dt><dd className="font-mono">piplight.com</dd></div>
        </dl>
      </div>
      <form onSubmit={submit} className="surface p-8 space-y-5">
        <div className="text-xs text-muted-foreground mb-2">
          Delivered to <span className="gold font-mono">investors@piplight.com</span>
        </div>
        <label className="block"><span className="kicker text-[10px] block mb-2">Name</span>
          <input required value={f.name} onChange={(e) => setF({...f, name: e.target.value})} data-testid="contact-name" className="fld" /></label>
        <label className="block"><span className="kicker text-[10px] block mb-2">Your Email</span>
          <input required type="email" value={f.email} onChange={(e) => setF({...f, email: e.target.value})} data-testid="contact-email" className="fld" /></label>
        <label className="block"><span className="kicker text-[10px] block mb-2">Subject</span>
          <input required value={f.subject} onChange={(e) => setF({...f, subject: e.target.value})} data-testid="contact-subject" className="fld" /></label>
        <label className="block"><span className="kicker text-[10px] block mb-2">Message</span>
          <textarea required rows={5} value={f.message} onChange={(e) => setF({...f, message: e.target.value})} data-testid="contact-message" className="fld resize-none" /></label>
        <button data-testid="contact-submit" disabled={busy} className="btn-gold px-6 py-3 text-sm uppercase tracking-widest disabled:opacity-50">{busy ? "Sending…" : "Send Message"}</button>
        <style>{`.fld{width:100%;background:hsl(226 20% 12%);border:1px solid hsl(226 20% 14%);padding:0.75rem 1rem;font-size:.875rem;color:inherit}.fld:focus{outline:none;border-color:hsl(41 40% 54%)}`}</style>
      </form>
    </div>
  );
}
